import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: LocalPagePaginatedDecisionMakersDataContext,
	Provider: LocalPagePaginatedDecisionMakersDataContextProvider,
	useContext: useLocalPagePaginatedDecisionMakersData,
	useAsyncData: useLocalPagePaginatedDecisionMakersDataFromApi,
	prefetchAsyncData: prefetchLocalPagePaginatedDecisionMakersDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'LocalPagePaginatedDecisionMakersDataContext',
	dataProperty: 'decisionMakersPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	hookDeps: (slug) => [slug],
	errorHandler: pageDataErrorHandler(),
});
